import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import SelectWithSearch from "../../../components/selectWithSearch";
import CheckBox from "../../../components/checkbox";
import _ from "lodash";
import { StyledLabel } from "../../../components/styles";
import { useHistory, useLocation } from "react-router-dom";
import { MileageUnitEditable, ErrorHint, AddWorkingCondition } from "./../styles";
import {
    SeparateLine,
    ButtonRow,
    Tags,
    PageTitle,
    ProjectInfo,
    WorkingConditionSteps,
    MileageUnit,
    MileageInput,
    DataView,
    TagsContainer,
    StyledAction,
    ActionsContainer,
    DeactivateReasonContainer,
    ObjectionContainer,
    ProjectFinancialLegalContainer,
    ConditionSteps,
    ProjectCondition,
} from "../../../styles/elements/main";
import {
    FormGroup,
    FormRow,
    FormGroupTextEditor,
    RowFormGroupContainer,
    Error,
    FormStyle,
    HintMessageContent,
} from "../../../styles/forms/main";
import {
    getPickupList,
    getConstantsList,
    submitWorkingConditionForm,
    getObjectionById,
    getTruckTypeList,
    uploadProjectInfoAttachments,
    updateProjectInfo,
    deleteSingleAttachment,
    deleteAllAttachments,
    getConditionById,
    updateProfileForm,
    getStandardsAndProceduresList,
} from "../api";
import Input from "../../../components/input";
import {
    mapOptionsToUi,
    mapConstantsToUi,
    filterArrayByString,
    mapSalesConditionToUi,
    mapObjectionsToUi,
} from "../mapToUi";
import TextArea from "../../../components/textArea";
import DatePickerInput from "../../../components/datePicker";
import DatePickerTimeOnlyInput from "../../../components/datePickerTimeOnly";
import Button from "../../../components/button";
import AccordionComponent from "../../../components/accordion";
import TabList from "../../../components/tabList";

import Action from "../../../components/dropdownAction";
import {
    mapUpdateSalesFormToData,
    mapAddWorkingConditionFormToData,
    mapUpdateSalesProjectInfoToData,
} from "./../mapToData";
import { setMessage } from "./../../shared/notification/slice";
import { useDispatch, useSelector } from "react-redux";
import { userRoles } from "./../../../constants/userRoles";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import DeactivateModal from "./deactivateModal";
import ObjectionsView from "./objectionsView";
import trackAnalytics from "./../../../trackAnalytics";
import { showLoader } from "../../shared/FullPageLoader/slice";
import { isEmpty } from "../../shared/utils/checkIsEmptyArray";
import ProjectFinancialLegalForm from "./ProjectFinancialLegal";
import QADetails from "./QADetails";
import { convertFileToBase64 } from "../../../utils/getBase64";
import ModalComponent from "../../../components/modal";
import Spinner from "../../../components/Spinner";
import SupplierPricingDetails from "./SupplierPricingDetails";
import ClientPricingDetails from "./ClientPricingDetails";
import { getUserRoles } from "../../auth/slice";
import { compareObjects } from "../../../hooks/compareObjects";
import {
    mapSalesWorkingConditionsDataToMixPanel,
    mapUpdateProjectInfoToMixPanel,
} from "../mapDataToMixpanel";
import ExtraOperationalRequirements from "./ExtraOperationalRequirements";
import { EuiSwitch } from "@elastic/eui";

export default function SalesProfile({
    clientProjectData,
    projectId,
    organizationId,
    monthlyProjectId,
    penaltiesAndDeductions,
    setPenaltiesAndDeductions,
    setAllIllaDeductions,
    setAllClientDeductions,
    allIllaDeductions,
    allClientDeductions,
}) {
    const [salesWorkingConditionIsValid, setSalesWorkingConditionIsValid] = useState(true);
    const [activeWorkingCondition, setActiveWorkingCondition] = useState(0);
    const [editableConditionId, setEditableConditionId] = useState(0);
    const [isEditable, setIsEditable] = useState(false);
    const [truckTypesList, setTruckTypesList] = useState([]);
    const [standardsAndProceduresList, setStandardsAndProceduresList] = useState([]);
    const [pickupList, setPickupList] = useState([]);
    const [salesList, setSalesList] = useState([]);
    const [weekDayList, setWeekDayList] = useState([]);
    const [serviceArea, setServiceArea] = useState([]);
    const [salesConditions, setSalesConditions] = useState({});
    const [clickOnSubmit, setClickOnSubmit] = useState(false);
    const [assignedTrucksNumber, setAssignedTrucksNumber] = useState(0);
    const [formIsValid, setFormIsValid] = useState();
    const [newWorkingCondition, setNewWorkingCondition] = useState({
        truckType: null,
        numberOfTrucks: 0,
        hasPreferredModelYear: false,
        requiredModelYearStartsFrom: null,
        hasPreferredModelYear: false,
        KickOffDate: null,
        endDate: null,
        salesChannels: [],
        serviceAreas: [],
        pickupLocation: null,
        pickUpTime: null,
        extraOperationalRequirements: [],
        weeklyOffDays: [],
        workingDaysPerMonth: 0,
        workingHoursPerDay: 0,
        kiloMeters: 0,
        operationalDetailsCheckbox: false,
        operationalDetailsSpecialRequired: "",
        numberOfHelpers: 0,
        deliveryDelegate: 0,
        facilitiesCheckbox: false,
        facilitiesSpecialRequired: "",
        truckPricePerMonth: "",
        extraDayPrice: "",
        extraHourPrice: "",
        extraUnitDistancePrice: "",
        extraKiloMeterPrice: "",
        overnightPrice: "",
        excludeGasAndOil: false,
        pricePerHelper: "",
        pricePerDelegate: "",
        goodsTransfer: false,
        cashCollection: false,
        distribution: false,
        scales: false,
        tolls: false,
        returnable: false,
        workingOvernight: false,
        workingOnHolidays: false,
        specialExtraOperationalRequirments: "",
    });
    const [addNewCondition, setAddNewCondition] = useState(false);
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [conditionId, setConditionId] = useState("");
    const dispatch = useDispatch();
    const history = useHistory();
    const [objection, setObjection] = useState({});
    const [clientProject, setClientProject] = useState(null);
    const [viewObjectionSection, setViewObjectionSection] = useState(true);
    const [activeObjection, setActiveObjection] = useState("");
    const [SubmitObjectSuccess, setSubmitObjectSuccess] = useState(false);
    const location = useLocation();
    const [isProjectInfoEditable, setIsProjectInfoEditable] = useState(false);
    const [showDiscardEditModal, setShowDiscardModal] = useState(false);
    // QA details sections
    const [qaDetails, setQaDetails] = useState({});
    const [operationalAttachments, setOperationalAttachments] = useState([]);
    // Project Financial section
    const [projectFinancialLegal, setProjectFinancialLegal] = useState({});
    const [salesAttachments, setSalesAttachments] = useState([]);
    const [supplierAttachments, setSupplierAttachments] = useState([]);
    const [targetPriceAttachments, setTargetPriceAttachments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isRfq, setIsRfq] = useState(false);
    const [projectName, setProjectName] = useState("");
    const getCurrentUserRoles = useSelector(getUserRoles());
    const [initConditionsData, setInitConditionsData] = useState({});

    useEffect(() => {
        setQaDetails(clientProject?.qaDetails);
        setProjectFinancialLegal(clientProject?.projectFinancialLegal);
        setProjectName(clientProject?.name);
        fetchStandardsAndProcedures();
        setIsRfq(clientProject?.isRfq);
        setPenaltiesAndDeductions(clientProject?.deductionsValues);
    }, [clientProject]);

    useEffect(() => {
        SubmitObjectSuccess && getObjection(activeObjection);
        setSubmitObjectSuccess(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SubmitObjectSuccess]);

    useEffect(() => {
        setClientProject(clientProjectData);
    }, [clientProjectData]);

    useEffect(() => {
        if (clickOnSubmit) {
            if (formIsValid) {
                handleSubmitForm();
            } else {
                setSalesWorkingConditionIsValid(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formIsValid, clickOnSubmit]);

    useEffect(() => {
        if (organizationId !== "" && (isEditable || addNewCondition)) {
            fetchPickUpList();
            fetchConstantsList();
            fetchTruckTypes();
        }
        addNewCondition && setSalesConditions(newWorkingCondition);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditable, organizationId, addNewCondition]);

    useEffect(() => {
        if (clientProject?.salesConditionsId?.length > 0 && !addNewCondition) {
            fetchSalesProfileCondition(clientProject?.salesConditionsId[0]);
            setConditionId(clientProject?.salesConditionsId[0]);
            setEditableConditionId(clientProject?.salesConditionsId[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientProject, addNewCondition]);

    useEffect(() => {
        if (!addNewCondition && salesConditions) {
            salesConditions && setAssignedTrucksNumber(salesConditions?.numberOfTrucks);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesConditions, assignedTrucksNumber]);

    useEffect(() => {
        if (objection) {
            setSalesConditions({ ...salesConditions, objection });
        } else {
            setSalesConditions({ ...salesConditions, objection: undefined });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objection]);

    const checkFormValidation = (e) => {
        e.preventDefault();
        checkWorkingConditionValidation();
        setClickOnSubmit(true);
    };
    const checkIsFormValid = (data) => {
        let validateWorkingCondition = true;
        if (
            isEmpty([
                data?.truckType,
                data?.kickoffDate,
                data?.pickUpLocation,
                data?.pickUpTime === "",
            ]) ||
            Number(data?.numberOfTrucks) === 0 ||
            data?.serviceAreas.length === 0 ||
            data?.weeklyOffDays.length === 0 ||
            (data?.weeklyOffDays.length > 1 &&
                data?.weeklyOffDays.some((value) => value?.label?.toLowerCase() === "none")) ||
            Number(data?.workingDaysPerMonth) === 0 ||
            Number(data?.workingHoursPerDay) === 0 ||
            Number(data?.truckPricePerMonth) === 0 ||
            Number(data?.extraDayPrice) === 0 ||
            Number(data?.extraHourPrice) === 0 ||
            Number(data?.extraUnitDistancePrice) === 0 ||
            (data?.workingOvernight && Number(data?.overnightPrice) === 0) ||
            (Number(data?.numberOfHelpers) > 0 && Number(data?.pricePerHelper) === 0) ||
            (Number(data?.deliveryDelegate) > 0 && Number(data?.pricePerDelegate) === 0) ||
            Number(data?.kiloMeters) === 0 ||
            (data?.excludeGasAndOil && Number(data?.oilPricePerKilometer) === 0) ||
            (data?.excludeGasAndOil && Number(data?.fuelPricePerKilometer) === 0) ||
            (data?.operationalDetailsCheckbox && isEmpty([data?.operationalSpecialDetails])) ||
            (data?.hasPreferredModelYear && isEmpty([data?.requiredModelYearStartsFrom])) ||
            (data?.facilitiesCheckbox && isEmpty([data?.facilitatorsSpecialDetails]))
        ) {
            validateWorkingCondition = false;
        } else validateWorkingCondition = true;

        return validateWorkingCondition;
    };
    const checkWorkingConditionValidation = () => {
        setClickOnSubmit(false);
        setFormIsValid(undefined);
        if (isEditable && !addNewCondition) {
            setFormIsValid(checkIsFormValid(salesConditions));
        }
        if (addNewCondition) {
            setFormIsValid(checkIsFormValid(newWorkingCondition));
        }
    };

    const fetchTruckTypes = async (filterValue) => {
        const data = await getTruckTypeList(filterValue);

        if (
            filterValue &&
            mapOptionsToUi(_.values(data.entities["truckTypes"]), "id", "alias").length > 0
        ) {
            return mapOptionsToUi(_.values(data.entities["truckTypes"]), "id", "alias");
        }
        if (!filterValue) {
            setTruckTypesList(mapOptionsToUi(_.values(data.entities["truckTypes"]), "id", "alias"));
        }
    };

    const fetchPickUpList = async (filterValue) => {
        const data = await getPickupList(filterValue, organizationId);
        setPickupList(mapOptionsToUi(_.values(data.entities["branches"]), "locationId", "nameEn"));
        return mapOptionsToUi(_.values(data.entities["branches"]), "locationId", "nameEn");
    };

    const fetchStandardsAndProcedures = async () => {
        const data = await getStandardsAndProceduresList();
        setStandardsAndProceduresList(
            mapOptionsToUi(
                _.values(data?.entities["standardsAndOperationalProcedures"]),
                "id",
                "description"
            )
        );
    };

    const fetchConstantsList = async () => {
        const { data } = await getConstantsList();
        setSalesList(mapConstantsToUi(data["sales_channels"], "key", "nameEn"));
        setWeekDayList(mapConstantsToUi(data["week_days"], "key", "nameEn"));
        setServiceArea(mapConstantsToUi(data["service_areas"], "key", "nameEn"));
    };
    const filterSalesList = (filterValue) => filterArrayByString(salesList, filterValue);
    const fetchSalesProfileCondition = async (conditionId) => {
        const data = await getConditionById(conditionId);
        setSalesConditions(
            mapSalesConditionToUi(
                _.values(data?.entities["monthlyProjectTruckTypeConditions"]),
                _.values(data?.entities["truckTypes"]),
                _.values(data?.entities["branches"]),
                _.values(data?.entities["objections"]),
                _.values(data?.entities["suppliers"])
            )
        );
        setInitConditionsData(
            mapSalesConditionToUi(
                _.values(data?.entities["monthlyProjectTruckTypeConditions"]),
                _.values(data?.entities["truckTypes"]),
                _.values(data?.entities["branches"]),
                _.values(data?.entities["objections"]),
                _.values(data?.entities["suppliers"])
            )
        );
        if (_.values(data?.entities["objections"]).length > 0) {
            const objectLength = Object.keys(_.values(data?.entities["objections"])).length;
            getObjection(_.values(data?.entities["objections"])[objectLength - 1]?.id);
            setActiveObjection(_.values(data?.entities["objections"])[objectLength - 1]?.id);
        }
    };

    const FetchProjectProfileCondition = (conditionId) => {
        if (conditionId !== "") {
            fetchSalesProfileCondition(conditionId);
        }
    };

    const handleEdit = () => {
        setIsEditable(true);
        trackAnalytics(`${getCurrentUserRoles}]_working_condition_edit`);
    };
    const handleDeactivate = () => {
        setShowDeactivateModal(true);
    };
    const handleSubmitForm = () => {
        if (addNewCondition) {
            if (monthlyProjectId) {
                const FormData = mapAddWorkingConditionFormToData(
                    monthlyProjectId,
                    newWorkingCondition
                );
                FormData &&
                    submitWorkingConditionForm(FormData)
                        .then(async (res) => {
                            setIsEditable(false);
                            setFormIsValid();
                            setAddNewCondition(false);

                            const response = await res;
                            const id = _.values(
                                response.entities["monthlyProjectSalesConditions"]
                            )[0]["attributes"].monthlyProjectId;
                            const numberOfWorkingConditions =
                                clientProject?.salesConditionsId?.length;
                            trackAnalytics("Successful New Working Conditions Submissions", {
                                "Number of working Conditions": numberOfWorkingConditions,
                                "project id": id,
                            });

                            dispatch(
                                setMessage({
                                    content: `project profile condition updated successfully `,
                                    isError: false,
                                })
                            );
                            history.push({
                                pathname: `/clientProjects/${id}`,
                                state: {
                                    projectId: id,
                                    clientId: organizationId,
                                    entityName: "projects",
                                },
                            });
                            dispatch(showLoader());
                            window.location.reload(false);
                        })
                        .catch((error) => {
                            setClickOnSubmit(false);
                            setIsEditable(true);
                            setFormIsValid(false);
                            trackAnalytics("Failure New Working Conditions Submissions");

                            dispatch(
                                setMessage({
                                    content: error,
                                    title: `Couldn't update project profile conditions  `,
                                    isError: true,
                                })
                            );
                        });
            }
        } else {
            const changedProps = compareObjects(initConditionsData, salesConditions);
            const FormData = mapUpdateSalesFormToData(editableConditionId, salesConditions);
            const workingConditionsMixPanelData = mapSalesWorkingConditionsDataToMixPanel(
                changedProps,
                clientProject?.status,
                salesConditions?.status
            );
            FormData &&
                updateProfileForm(editableConditionId, FormData)
                    .then(async (res) => {
                        setIsEditable(false);
                        setFormIsValid();

                        const response = await res;
                        trackAnalytics(
                            `Save project info edits submissions `,
                            workingConditionsMixPanelData
                        );
                        const id = _.values(response.entities["monthlyProjectSalesConditions"])[0][
                            "attributes"
                        ].monthlyProjectId;

                        dispatch(
                            setMessage({
                                content: `project profile condition updated successfully `,
                                isError: false,
                            })
                        );
                        history.push({
                            pathname: `/clientProjects/${id}`,
                            state: {
                                projectId: id,
                                clientId: organizationId,
                                entityName: "projects",
                            },
                        });
                        dispatch(showLoader());
                        window.location.reload(false);
                    })
                    .catch((error) => {
                        setClickOnSubmit(false);
                        setIsEditable(true);
                        setFormIsValid(false);

                        dispatch(
                            setMessage({
                                content: error,
                                title: `Couldn't update project profile conditions  `,
                                isError: true,
                            })
                        );
                    });
        }
    };
    useEffect(() => {
        addNewCondition && setActiveWorkingCondition(clientProject?.salesConditionsId?.length);
    }, [clientProject, addNewCondition]);

    const addWorkingCondition = () => {
        setSalesConditions(newWorkingCondition);
        setObjection(undefined);
        setFormIsValid(true);
        setClientProject({
            ...clientProject,
            salesConditionsId: [...clientProject?.salesConditionsId, ""],
        });
        setViewObjectionSection(false);
        setAddNewCondition(true);
    };

    const handleOnChangeSelect = (value, fieldName) => {
        setNewWorkingCondition({ ...newWorkingCondition, [fieldName]: value });
    };
    const handleOnClick = (item) => {
        getObjection(item?.id);
        setActiveObjection(item?.id);
    };

    const getObjection = async (objectionId) => {
        const data = await getObjectionById(objectionId);

        setObjection(
            mapObjectionsToUi(
                _.values(data?.entities["creators"]),
                _.values(data?.entities["mentionedAdminUsers"]),
                _.values(data?.entities["adminUsers"]),
                _.values(data?.entities["items"]),
                _.values(data?.entities["sections"]),
                _.values(data?.entities["comments"]),
                _.values(data?.entities["objections"])
            )
        );
    };

    const handleEditProjectInfo = () => {
        trackAnalytics("Edit Project info clicks");
        setIsProjectInfoEditable(true);
    };

    const handleSubmitProjectInfo = () => {
        setIsLoading(true);
        updateAttachments();
    };

    const updateAttachments = async () => {
        if (
            salesAttachments.length > 0 ||
            operationalAttachments.length > 0 ||
            supplierAttachments.length > 0 ||
            targetPriceAttachments.length > 0
        ) {
            const allAttachments = [
                { type: "sales_contract", files: salesAttachments },
                { type: "operational", files: operationalAttachments },
                { type: "supply_contract", files: supplierAttachments },
                { type: "target_price_document", files: targetPriceAttachments },
            ];
            for (const attachment of allAttachments) {
                await Promise.all(
                    attachment.files.map(async (document) => {
                        try {
                            const file = await convertFileToBase64(document);
                            const data = {
                                data: {
                                    type: "attachments",
                                    attributes: {
                                        attachedItemId: projectId,
                                        attachedItemType: "Project",
                                        documentType: attachment.type,
                                        document: file,
                                    },
                                },
                            };
                            const response = await uploadProjectInfoAttachments(data);
                            const attachments = _.values(response?.entities["attachments"]);
                            const extractedAttachments = attachments.map((attachment) => {
                                const { documentType, document } = attachment?.attributes;
                                const url = document && document.url ? document.url : null;
                                return { documentType, url };
                            });

                            trackAnalytics(
                                `${getCurrentUserRoles}_project_info_save_edit`,
                                ...extractedAttachments
                            );
                        } catch (err) {
                            dispatch(
                                setMessage({
                                    content: err,
                                    title: `Couldn't update project profile attachments  `,
                                    isError: true,
                                })
                            );
                        }
                    })
                );
            }
            updateProject();
        } else {
            updateProject();
        }
    };
    // * updateProject() for sending updates to the server
    const updateProject = () => {
        const data = {
            qaDetails,
            projectFinancialLegal,
            projectName,
            isRfq,
        };
        const changedProps = compareObjects(clientProject, { ...clientProject, ...data });
        const formData = mapUpdateSalesProjectInfoToData(
            projectId,
            data,
            penaltiesAndDeductions,
            isRfq
        );
        const mixPanelData = mapUpdateProjectInfoToMixPanel(
            changedProps,
            projectId,
            clientProject?.status
        );
        updateProjectInfo(projectId, formData)
            .then((res) => {
                setIsLoading(false);
                trackAnalytics(`Save project info edits submissions`, mixPanelData);
                dispatch(
                    setMessage({
                        content: `project profile condition updated successfully `,
                        isError: false,
                    })
                );
                history.push({
                    pathname: `/clientProjects/${projectId}`,
                    state: { clientId: organizationId, entityName: "projects" },
                });
                dispatch(showLoader());
                window.location.reload(false);
            })
            .catch((err) => {
                setIsLoading(false);
                dispatch(
                    setMessage({
                        content: err,
                        title: `Couldn't update project profile info  `,
                        isError: true,
                    })
                );
            });
    };

    const handleDeleteUploadedItem = (id) => {
        deleteSingleAttachment(id).then(() => {
            dispatch(
                setMessage({
                    content: `Attachment deleted successfully`,
                    isError: false,
                })
            );
            history.push({
                pathname: `/clientProjects/${projectId}`,
                state: { clientId: organizationId, entityName: "projects" },
            });
            dispatch(showLoader());
            window.location.reload(false);
        });
    };

    const handleDeleteAllAttachements = () => {
        deleteAllAttachments().then((res) => {
            dispatch(
                setMessage({
                    content: `Attachments deleted successfully`,
                    isError: false,
                })
            );
            history.push({
                pathname: `/clientProjects/${projectId}`,
                state: { clientId: organizationId, entityName: "projects" },
            });
            dispatch(showLoader());
            window.location.reload(false);
        });
    };

    const objectionBody = () => (
        <ObjectionContainer>
            <TabList
                list={salesConditions?.objectionsId}
                handleOnClick={handleOnClick}
            />
            <ObjectionsView
                objection={salesConditions?.objection}
                activeObjectionId={activeObjection}
                projectId={projectId}
                submitObjectionSuccessfully={(value) => setSubmitObjectSuccess(value)}
            />
        </ObjectionContainer>
    );

    return (
        <>
            <FormStyle onSubmit={checkFormValidation}>
                <ProjectInfo>
                    <PageTitle>
                        <FormattedMessage id="client.project-create-header" /> #{projectId}
                        <TagsContainer>
                            <Tags>{clientProject?.status}</Tags>
                        </TagsContainer>
                    </PageTitle>
                    {!isProjectInfoEditable && (
                        <StyledAction>
                            <Action
                                options={[
                                    {
                                        name: "edit",
                                        eventHandler: () => handleEditProjectInfo(),
                                        disable: false,
                                    },
                                ]}
                                icon="<MoreVertIcon/>"
                            />
                        </StyledAction>
                    )}
                    <FormRow>
                        <FormGroup>
                            <StyledLabel>Client Name</StyledLabel>
                            <DataView>{clientProject?.clientName}</DataView>
                        </FormGroup>
                        <FormGroup>
                            <Input
                                isEditable={isProjectInfoEditable}
                                label="Project Name"
                                name="projectName"
                                type="text"
                                onChange={(e) => {
                                    setProjectName(e?.target?.value);
                                }}
                                required={false}
                                placeholder=""
                                value={projectName}
                            />
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        <FormGroup>
                            <StyledLabel>Project Type</StyledLabel>
                            <DataView>{clientProject?.projectType}</DataView>
                        </FormGroup>
                        <FormGroup>
                            <StyledLabel>Requested Date </StyledLabel>
                            <DataView>{clientProject?.requestedAt}</DataView>
                        </FormGroup>
                    </FormRow>
                    <FormRow>
                        <EuiSwitch
                            label="Request For Quotation “provide pricing details”"
                            checked={isRfq}
                            onChange={(e) => setIsRfq(e.target.checked)}
                            disabled={!isProjectInfoEditable}
                        />
                    </FormRow>
                    <ProjectFinancialLegalContainer>
                        <ProjectFinancialLegalForm
                            projectFinancialLegal={projectFinancialLegal}
                            isEditable={isProjectInfoEditable}
                            userRole="sales"
                            setFinancialLegal={(fieldName, value) => {
                                setProjectFinancialLegal({
                                    ...projectFinancialLegal,
                                    [fieldName]: value,
                                });
                            }}
                            setSalesAttachments={setSalesAttachments}
                            setTargetPriceAttachments={setTargetPriceAttachments}
                            setSupplierAttachments={setSupplierAttachments}
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            onDeleteAllAttachements={handleDeleteAllAttachements}
                            setAllIllaDeductions={setAllIllaDeductions}
                            setAllClientDeductions={setAllClientDeductions}
                            allIllaDeductions={allIllaDeductions}
                            allClientDeductions={allClientDeductions}
                            deductionsValues={penaltiesAndDeductions}
                            setDeductionsValues={setPenaltiesAndDeductions}
                        />
                    </ProjectFinancialLegalContainer>
                    <div>
                        <QADetails
                            isEditable={isProjectInfoEditable}
                            attachements={clientProject?.qaDetails?.attachments}
                            // User can edit any of the following attributes
                            qADetails={qaDetails}
                            setQaDetails={setQaDetails}
                            setOperationalAttachments={setOperationalAttachments}
                            userRole="sales_representative"
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            onDeleteAllAttachements={handleDeleteAllAttachements}
                            standardsAndProceduresList={standardsAndProceduresList}
                        />
                        <SeparateLine />
                    </div>
                    {isProjectInfoEditable && (
                        <ButtonRow>
                            <Button
                                type="button"
                                name="Cancel"
                                btnStyle="secondBtn"
                                onChange={() => setShowDiscardModal(true)}
                            />
                            <Button
                                type="button"
                                name={isLoading ? <Spinner /> : "Save"}
                                btnStyle="primaryBtn"
                                onChange={handleSubmitProjectInfo}
                            />
                        </ButtonRow>
                    )}
                    <ModalComponent
                        header="Discard edits"
                        open={showDiscardEditModal}
                        onClose={() => {
                            setShowDiscardModal(false);
                        }}
                        submitBtnText="Discard"
                        onSubmit={() => {
                            trackAnalytics(`${getCurrentUserRoles}_project_cancel_editing`);
                            setProjectFinancialLegal(clientProject?.projectFinancialLegal);
                            setQaDetails(clientProject?.qaDetails);
                            setShowDiscardModal(false);
                            setIsProjectInfoEditable(false);
                        }}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        If you discard it now, you'll lose all the edits you've made
                    </ModalComponent>
                </ProjectInfo>
                <div>
                    <WorkingConditionSteps>
                        {clientProject?.salesConditionsId?.map((item, index) => (
                            <ConditionSteps
                                className={index === activeWorkingCondition ? "active" : ""}
                                onClick={() => {
                                    setConditionId(item);
                                    setActiveWorkingCondition(index);
                                    if (item !== "") {
                                        setAddNewCondition(false);
                                        setIsEditable(false);
                                        FetchProjectProfileCondition(item);
                                        setViewObjectionSection(true);
                                        setEditableConditionId(item);
                                    } else {
                                        setSalesConditions(newWorkingCondition);
                                        setIsEditable(false);
                                        setEditableConditionId(item);
                                        setAddNewCondition(true);
                                        setViewObjectionSection(false);
                                    }
                                }}
                            >
                                Working condition {index + 1}
                            </ConditionSteps>
                        ))}
                        <AddWorkingCondition onClick={addWorkingCondition}>
                            <span>+</span>
                        </AddWorkingCondition>
                    </WorkingConditionSteps>
                    <ProjectCondition>
                        <>
                            {clientProject && (
                                <>
                                    <div>
                                        <ActionsContainer>
                                            {salesConditions?.status && !addNewCondition && (
                                                <Tags>{salesConditions?.status}</Tags>
                                            )}

                                            {!addNewCondition &&
                                                salesConditions?.deactivationReason === null && (
                                                    <StyledAction>
                                                        <Action
                                                            options={[
                                                                {
                                                                    name: "edit",
                                                                    eventHandler: () =>
                                                                        handleEdit(),
                                                                    disable: false,
                                                                },
                                                                {
                                                                    name: "deactivate",
                                                                    eventHandler: () =>
                                                                        handleDeactivate(),
                                                                    disable: false,
                                                                },
                                                            ]}
                                                            icon="<MoreVertIcon/>"
                                                        />
                                                    </StyledAction>
                                                )}
                                        </ActionsContainer>

                                        {/* will separate it to another component */}

                                        {salesConditions?.deactivationReason !== null &&
                                            !addNewCondition && (
                                                <DeactivateReasonContainer>
                                                    <WarningAmberIcon />
                                                    <HintMessageContent>
                                                        <h3>
                                                            this condition{" "}
                                                            {salesConditions?.deactivationStatus}
                                                        </h3>
                                                        <p>{salesConditions?.deactivationReason}</p>
                                                    </HintMessageContent>
                                                </DeactivateReasonContainer>
                                            )}

                                        <h3>Truck Details</h3>
                                        <FormRow>
                                            <FormGroup>
                                                <SelectWithSearch
                                                    isEditable={!!addNewCondition || isEditable}
                                                    isMulti={false}
                                                    label="Truck Type"
                                                    options={truckTypesList}
                                                    value={salesConditions?.truckType}
                                                    name="truckType"
                                                    placeholder="Truck Type"
                                                    required
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        (((isEditable || addNewCondition) &&
                                                            salesConditions?.truckType === null) ||
                                                            salesConditions?.truckType ===
                                                                undefined)
                                                    }
                                                    handleFilter={(value) =>
                                                        filterArrayByString(truckTypesList, value)
                                                    }
                                                    handleChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(e, "truckType");
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            truckType: e,
                                                        });
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Input
                                                    disableWithBorder={false}
                                                    isEditable={!!addNewCondition || isEditable}
                                                    label="Number Of Trucks"
                                                    name="numberOfTrucks"
                                                    type="number"
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e.target.value,
                                                                "numberOfTrucks"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            numberOfTrucks: e.target.value,
                                                        });
                                                    }}
                                                    required
                                                    placeholder={isEditable ? "0" : ""}
                                                    value={salesConditions?.numberOfTrucks}
                                                    min="1"
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        ((isEditable &&
                                                            salesConditions?.numberOfTruck === 0) ||
                                                            (salesConditions?.numberOfTrucks ===
                                                                0 &&
                                                                addNewCondition))
                                                    }
                                                />
                                            </FormGroup>
                                        </FormRow>
                                        <FormRow>
                                            <FormGroup>
                                                <CheckBox
                                                    label="Do you prefer specific truck model ?"
                                                    name="hasPreferredModelYear"
                                                    type="checkbox"
                                                    borderd
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e.target.checked,
                                                                "hasPreferredModelYear"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            hasPreferredModelYear: e.target.checked,
                                                        });
                                                    }}
                                                    value={salesConditions?.hasPreferredModelYear}
                                                    disabled={!addNewCondition && !isEditable}
                                                />
                                            </FormGroup>
                                            {salesConditions?.hasPreferredModelYear && (
                                                <FormGroup>
                                                    <SelectWithSearch
                                                        isEditable={isEditable || addNewCondition}
                                                        label="Required model year starts from "
                                                        options={
                                                            // years from 1980 to the current year
                                                            Array.from(
                                                                new Array(
                                                                    new Date().getFullYear() -
                                                                        1980 +
                                                                        1
                                                                ),
                                                                (val, index) => index + 1980
                                                            ).map((year) => ({
                                                                value: year,
                                                                label: year,
                                                            }))
                                                        }
                                                        handleChange={(e) => {
                                                            addNewCondition &&
                                                                handleOnChangeSelect(
                                                                    e,
                                                                    "requiredModelYearStartsFrom"
                                                                );
                                                            setSalesConditions({
                                                                ...salesConditions,
                                                                requiredModelYearStartsFrom: e,
                                                            });
                                                        }}
                                                        value={
                                                            salesConditions?.requiredModelYearStartsFrom
                                                        }
                                                        name="requiredModelYearStartsFrom"
                                                        placeholder="Select Year"
                                                        required={
                                                            salesConditions?.hasPreferredModelYear
                                                        }
                                                        // error={
                                                        //     !formIsValid &&
                                                        //     !workingConditions[activeWorkingCondition]
                                                        //         ?.requiredModelYearStartsFrom.length === 0
                                                        // }
                                                    />
                                                </FormGroup>
                                            )}
                                        </FormRow>
                                        <SeparateLine />
                                    </div>
                                    <ExtraOperationalRequirements
                                        isEditable={isEditable || addNewCondition}
                                        workingCondition={salesConditions}
                                        onChange={(value, attribute) => {
                                            addNewCondition &&
                                                handleOnChangeSelect(value, attribute);
                                            setSalesConditions({
                                                ...salesConditions,
                                                [attribute]: value,
                                            });
                                        }}
                                    />
                                    <div>
                                        <h3>Operational Details</h3>
                                        <FormRow>
                                            <FormGroup>
                                                <DatePickerInput
                                                    isEditable={isEditable || addNewCondition}
                                                    name="KickOffDate"
                                                    selectedValue={salesConditions?.kickoffDate}
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(e, "kickoffDate");
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            kickoffDate: e,
                                                        });
                                                    }}
                                                    required="true"
                                                    label="Kick-off Date"
                                                    dateFormat="dd/MM/yyyy"
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        salesConditions?.kickoffDate === null
                                                    }
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <DatePickerInput
                                                    isEditable={isEditable || addNewCondition}
                                                    name="endDate"
                                                    selectedValue={salesConditions?.endDate}
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(e, "endDate");
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            endDate: e,
                                                        });
                                                    }}
                                                    required="true"
                                                    label="End Date"
                                                    dateFormat="dd/MM/yyyy"
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        salesConditions?.endDate === null
                                                    }
                                                />
                                            </FormGroup>
                                        </FormRow>
                                        <FormGroup>
                                            <Input
                                                label="Maximum number of drop-offs"
                                                name="maximumNumberOfDropOff"
                                                type="number"
                                                onChange={(e) => {
                                                    addNewCondition &&
                                                        handleOnChangeSelect(
                                                            e.target.value,
                                                            "maximumNumberOfDropOff"
                                                        );
                                                    setSalesConditions({
                                                        ...salesConditions,
                                                        maximumNumberOfDropOff: e.target.value,
                                                    });
                                                }}
                                                isEditable={isEditable || addNewCondition}
                                                value={
                                                    salesConditions?.maximumNumberOfDropOff || ""
                                                }
                                                required
                                                placeholder="0"
                                                min="1"
                                                error={
                                                    !salesWorkingConditionIsValid &&
                                                    ((isEditable &&
                                                        salesConditions?.maximumNumberOfDropOff ===
                                                            "") ||
                                                        (addNewCondition &&
                                                            salesConditions?.maximumNumberOfDropOff ===
                                                                ""))
                                                }
                                            />
                                        </FormGroup>
                                        <FormRow>
                                            <FormGroup>
                                                <SelectWithSearch
                                                    isEditable={isEditable || addNewCondition}
                                                    isMulti
                                                    label="Sales Channels"
                                                    options={salesList}
                                                    handleFilter={(value) => filterSalesList(value)}
                                                    handleChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e,
                                                                "salesChannels"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            salesChannels: e,
                                                        });
                                                    }}
                                                    value={salesConditions?.salesChannels}
                                                    name="salesChannels"
                                                    placeholder="Sales Channels"
                                                    required
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        ((isEditable &&
                                                            salesConditions?.salesChannels
                                                                ?.length === 0) ||
                                                            (addNewCondition &&
                                                                salesConditions?.salesChannels
                                                                    ?.length === 0))
                                                    }
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <SelectWithSearch
                                                    isEditable={isEditable || addNewCondition}
                                                    isMulti
                                                    label="Working Area"
                                                    options={serviceArea}
                                                    handleFilter={(value) =>
                                                        filterArrayByString(serviceArea, value)
                                                    }
                                                    handleChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(e, "serviceAreas");
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            serviceAreas: e,
                                                        });
                                                    }}
                                                    value={salesConditions?.serviceAreas}
                                                    name="workingArea"
                                                    placeholder="Working Area"
                                                    required
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        (isEditable || addNewCondition) &&
                                                        salesConditions?.serviceAreas?.length === 0
                                                    }
                                                />
                                            </FormGroup>
                                        </FormRow>
                                        <FormRow>
                                            <FormGroup>
                                                <SelectWithSearch
                                                    isEditable={isEditable || addNewCondition}
                                                    isMulti={false}
                                                    label="Pickup Location"
                                                    options={pickupList}
                                                    handleFilter={(value) => fetchPickUpList(value)}
                                                    handleChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e,
                                                                "pickUpLocation"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            pickUpLocation: e,
                                                        });
                                                    }}
                                                    value={salesConditions?.pickUpLocation}
                                                    name="PickupLocation"
                                                    placeholder="Pickup Location"
                                                    required
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        (isEditable || addNewCondition) &&
                                                        (salesConditions?.pickUpLocation === null ||
                                                            salesConditions?.pickUpLocation ===
                                                                undefined)
                                                    }
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <DatePickerTimeOnlyInput
                                                    isEditable={isEditable || addNewCondition}
                                                    name="pickupArrivalTime"
                                                    selectedValue={
                                                        salesConditions?.pickUpTime?.getTime() || ""
                                                    }
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(e, "pickUpTime");
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            pickUpTime: e,
                                                        });
                                                    }}
                                                    required="true"
                                                    label="Pickup Arrival Time"
                                                    dateFormat="h:mm aa"
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        (isEditable || addNewCondition) &&
                                                        salesConditions?.pickUpTime === null
                                                    }
                                                />
                                            </FormGroup>
                                        </FormRow>
                                        <FormRow>
                                            <FormGroup>
                                                <SelectWithSearch
                                                    isEditable={isEditable || addNewCondition}
                                                    isMulti
                                                    label="Weekly Off Days"
                                                    options={weekDayList}
                                                    handleFilter={(value) =>
                                                        filterArrayByString(weekDayList, value)
                                                    }
                                                    handleChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e,
                                                                "weeklyOffDays"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            weeklyOffDays: e,
                                                        });
                                                    }}
                                                    value={salesConditions?.weeklyOffDays}
                                                    name="weeklyOffDays"
                                                    placeholder="Weekly Off Days"
                                                    required
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        ((isEditable &&
                                                            salesConditions?.weeklyOffDays
                                                                ?.length === 0) ||
                                                            (addNewCondition &&
                                                                salesConditions?.weeklyOffDays
                                                                    ?.length === 0) ||
                                                            (salesConditions?.weeklyOffDays
                                                                ?.length > 1 &&
                                                                salesConditions?.weeklyOffDays?.some(
                                                                    (value) =>
                                                                        value?.label?.toLowerCase() ===
                                                                        "none"
                                                                )))
                                                    }
                                                    errorMsg={
                                                        !salesWorkingConditionIsValid &&
                                                        salesConditions?.weeklyOffDays?.length >
                                                            1 &&
                                                        salesConditions?.weeklyOffDays?.some(
                                                            (value) =>
                                                                value.label.toLowerCase() === "none"
                                                        )
                                                            ? "can’t choose none as long as you has chosen any week days"
                                                            : undefined
                                                    }
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Input
                                                    disableWithBorder={false}
                                                    isEditable={isEditable || addNewCondition}
                                                    label="Number of Working Days per Month"
                                                    name="workingDaysPerMonth"
                                                    type="number"
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e.target.value,
                                                                "workingDaysPerMonth"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            workingDaysPerMonth: e.target.value,
                                                        });
                                                    }}
                                                    required
                                                    placeholder={isEditable ? "0" : ""}
                                                    value={
                                                        salesConditions?.workingDaysPerMonth || ""
                                                    }
                                                    max="30"
                                                    min="1"
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        ((isEditable &&
                                                            salesConditions?.workingDaysPerMonth ===
                                                                "") ||
                                                            (addNewCondition &&
                                                                salesConditions?.workingDaysPerMonth ===
                                                                    ""))
                                                    }
                                                />
                                            </FormGroup>
                                        </FormRow>
                                        <FormRow>
                                            <FormGroup>
                                                <Input
                                                    disableWithBorder={false}
                                                    isEditable={isEditable || addNewCondition}
                                                    label="Working Hours per Day"
                                                    name="workingHoursPerDay"
                                                    type="number"
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e.target.value,
                                                                "workingHoursPerDay"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            workingHoursPerDay: e.target.value,
                                                        });
                                                    }}
                                                    required
                                                    placeholder={isEditable ? "1" : ""}
                                                    value={
                                                        salesConditions?.workingHoursPerDay || ""
                                                    }
                                                    max="24"
                                                    min="1"
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        ((isEditable &&
                                                            salesConditions?.workingHoursPerDay ===
                                                                "") ||
                                                            (addNewCondition &&
                                                                salesConditions?.workingHoursPerDay ===
                                                                    ""))
                                                    }
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <MileageInput>
                                                    <Input
                                                        disableWithBorder={false}
                                                        isEditable={isEditable || addNewCondition}
                                                        label="Mileage"
                                                        name="Mileage"
                                                        type="number"
                                                        onChange={(e) => {
                                                            addNewCondition &&
                                                                handleOnChangeSelect(
                                                                    e.target.value,
                                                                    "kiloMeters"
                                                                );
                                                            setSalesConditions({
                                                                ...salesConditions,
                                                                kiloMeters: e.target.value,
                                                            });
                                                        }}
                                                        required
                                                        placeholder={isEditable ? "1" : ""}
                                                        value={salesConditions?.kiloMeters}
                                                        min="1"
                                                        error={
                                                            !salesWorkingConditionIsValid &&
                                                            ((isEditable &&
                                                                salesConditions?.kiloMeters ===
                                                                    0) ||
                                                                (addNewCondition &&
                                                                    salesConditions?.kiloMeters ===
                                                                        0))
                                                        }
                                                    />
                                                    {isEditable ? (
                                                        <MileageUnit>KM</MileageUnit>
                                                    ) : (
                                                        <MileageUnitEditable>
                                                            KM
                                                        </MileageUnitEditable>
                                                    )}
                                                </MileageInput>
                                            </FormGroup>
                                        </FormRow>

                                        {salesConditions?.operationalDetailsCheckbox && (
                                            <TextArea
                                                isEditable={isEditable || addNewCondition}
                                                type="text"
                                                name="operationalSpecialDetails"
                                                onChange={(e) => {
                                                    addNewCondition &&
                                                        handleOnChangeSelect(
                                                            e.target.value,
                                                            "operationalSpecialDetails"
                                                        );
                                                    setSalesConditions({
                                                        ...salesConditions,
                                                        operationalSpecialDetails: e.target.value,
                                                    });
                                                }}
                                                label="Special Requirements for Operational"
                                                placeholder=""
                                                value={salesConditions?.operationalSpecialDetails}
                                                error={
                                                    (!salesWorkingConditionIsValid &&
                                                        isEditable &&
                                                        salesConditions?.operationalSpecialDetails ===
                                                            "") ||
                                                    (addNewCondition &&
                                                        salesConditions?.operationalSpecialDetails ===
                                                            "")
                                                }
                                                required={
                                                    salesConditions?.operationalDetailsCheckbox
                                                }
                                            />
                                        )}

                                        <SeparateLine />
                                    </div>

                                    <div>
                                        <h3>Facilitators</h3>
                                        <FormRow>
                                            <FormGroup>
                                                <Input
                                                    disableWithBorder={false}
                                                    isEditable={isEditable || addNewCondition}
                                                    label="No. of Helpers"
                                                    name="numberOfHelpers"
                                                    type="number"
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e.target.value,
                                                                "numberOfHelpers"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            numberOfHelpers: e.target.value,
                                                        });
                                                    }}
                                                    required={false}
                                                    placeholder={isEditable ? "0" : ""}
                                                    value={salesConditions?.numberOfHelpers}
                                                    min="0"
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Input
                                                    disableWithBorder={false}
                                                    isEditable={isEditable || addNewCondition}
                                                    label="No. of Delivery Delegates"
                                                    name="numberOfDelegates"
                                                    type="number"
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e.target.value,
                                                                "deliveryDelegate"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            deliveryDelegate: e.target.value,
                                                        });
                                                    }}
                                                    required={false}
                                                    placeholder={isEditable ? "0" : ""}
                                                    value={salesConditions?.deliveryDelegate}
                                                    min="0"
                                                />
                                            </FormGroup>
                                        </FormRow>
                                        <FormRow>
                                            {(addNewCondition || isEditable) && (
                                                <CheckBox
                                                    label="does the client have special requirements for Facilities details ?"
                                                    name="facilitiesCheckbox"
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e.target.checked,
                                                                "facilitiesCheckbox"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            facilitiesCheckbox: e.target.checked,
                                                        });
                                                    }}
                                                    value={salesConditions?.facilitiesCheckbox}
                                                />
                                            )}
                                            {salesConditions?.facilitiesCheckbox && (
                                                <TextArea
                                                    isEditable={isEditable || addNewCondition}
                                                    type="text"
                                                    name="facilitiesSpecialRequired"
                                                    onChange={(e) => {
                                                        addNewCondition &&
                                                            handleOnChangeSelect(
                                                                e.target.value,
                                                                "facilitatorsSpecialDetails"
                                                            );
                                                        setSalesConditions({
                                                            ...salesConditions,
                                                            facilitatorsSpecialDetails:
                                                                e.target.value,
                                                        });
                                                    }}
                                                    label="Special Requirements for Facilities"
                                                    placeholder=""
                                                    value={
                                                        salesConditions?.facilitatorsSpecialDetails
                                                    }
                                                    error={
                                                        !salesWorkingConditionIsValid &&
                                                        ((isEditable &&
                                                            salesConditions?.facilitatorsSpecialDetails ===
                                                                "") ||
                                                            (addNewCondition &&
                                                                salesConditions?.facilitatorsSpecialDetails ===
                                                                    ""))
                                                    }
                                                    required={salesConditions?.facilitiesCheckbox}
                                                />
                                            )}
                                        </FormRow>
                                        <SeparateLine />
                                    </div>

                                    <ClientPricingDetails
                                        isEditable={isEditable}
                                        clientProjectData={clientProjectData}
                                        addNewCondition={addNewCondition}
                                        handleOnChangeSelect={handleOnChangeSelect}
                                        setSalesConditions={setSalesConditions}
                                        salesConditions={salesConditions}
                                        salesWorkingConditionIsValid={salesWorkingConditionIsValid}
                                    />
                                    {salesConditions?.supplierConditions?.supplierCreatorId &&
                                        !addNewCondition && (
                                            <SupplierPricingDetails
                                                supplierConditions={salesConditions}
                                                isEditable={false}
                                            />
                                        )}

                                    {salesConditions?.supplierConditions?.supplierCreatorId !==
                                        null &&
                                        salesConditions?.supplierConditions?.supplierCreatorId !==
                                            undefined &&
                                        !addNewCondition && (
                                            <div>
                                                <SeparateLine />
                                                <h3> Supply Fulfillment Details </h3>
                                                {salesConditions?.supplierConditions?.projectMonthlySuppliers.map(
                                                    (supplier) => (
                                                        <>
                                                            <FormRow>
                                                                <FormGroup>
                                                                    <StyledLabel>
                                                                        Supplier
                                                                    </StyledLabel>
                                                                    <DataView>
                                                                        {supplier?.supplier}
                                                                    </DataView>
                                                                </FormGroup>
                                                                <FormGroup>
                                                                    <StyledLabel>
                                                                        number Of Trucks
                                                                    </StyledLabel>
                                                                    <DataView>
                                                                        {supplier?.numberOfTrucks}
                                                                    </DataView>
                                                                </FormGroup>
                                                            </FormRow>
                                                            {supplier?.numberOfTrucks > 0 &&
                                                                supplier?.assignedTrucks.length >
                                                                    0 &&
                                                                supplier?.assignedTrucks?.map(
                                                                    (truck, index) => (
                                                                        <FormRow>
                                                                            <RowFormGroupContainer>
                                                                                <FormGroup>
                                                                                    <StyledLabel>
                                                                                        {`Truck ${
                                                                                            index +
                                                                                            1
                                                                                        }`}
                                                                                    </StyledLabel>
                                                                                    <DataView>
                                                                                        {
                                                                                            truck.truck
                                                                                        }
                                                                                    </DataView>
                                                                                </FormGroup>
                                                                                <FormGroup>
                                                                                    <StyledLabel>
                                                                                        {`Driver ${
                                                                                            index +
                                                                                            1
                                                                                        }`}
                                                                                    </StyledLabel>
                                                                                    <DataView>
                                                                                        {
                                                                                            truck.driver
                                                                                        }
                                                                                    </DataView>
                                                                                </FormGroup>
                                                                            </RowFormGroupContainer>
                                                                        </FormRow>
                                                                    )
                                                                )}
                                                        </>
                                                    )
                                                )}
                                                <FormRow>
                                                    <FormGroup>
                                                        <StyledLabel>
                                                            Number of delivery Delegates
                                                        </StyledLabel>
                                                        <DataView>
                                                            {
                                                                salesConditions?.supplierConditions
                                                                    ?.supplierDeliveryDelegate
                                                            }
                                                        </DataView>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <StyledLabel>Number of Helpers</StyledLabel>
                                                        <DataView>
                                                            {
                                                                salesConditions?.supplierConditions
                                                                    ?.supplierNumberOfHelpers
                                                            }
                                                        </DataView>
                                                    </FormGroup>
                                                </FormRow>

                                                {salesConditions?.supplierConditions
                                                    ?.supplierOtherDetails && (
                                                    <FormRow>
                                                        <FormGroupTextEditor>
                                                            <StyledLabel>
                                                                Other Details{" "}
                                                            </StyledLabel>
                                                            <DataView>
                                                                {
                                                                    salesConditions
                                                                        ?.supplierConditions
                                                                        ?.supplierOtherDetails
                                                                }
                                                            </DataView>
                                                        </FormGroupTextEditor>
                                                    </FormRow>
                                                )}
                                            </div>
                                        )}
                                </>
                            )}
                            {!salesWorkingConditionIsValid &&
                                !formIsValid &&
                                (isEditable || addNewCondition) && (
                                    <FormRow>
                                        <ErrorHint>
                                            <Error>Please Fill the Required Field</Error>
                                        </ErrorHint>
                                    </FormRow>
                                )}
                            {(isEditable || addNewCondition) && (
                                <ButtonRow>
                                    <Button
                                        type="submit"
                                        name={isEditable ? "Edit" : "Submit"}
                                        btnStyle="primaryBtn"
                                    />
                                </ButtonRow>
                            )}
                        </>
                    </ProjectCondition>
                </div>
            </FormStyle>

            <DeactivateModal
                isShow={showDeactivateModal}
                activeWorkingCondition
                conditionId={conditionId}
                onHide={() => {
                    setShowDeactivateModal(false);
                }}
                role={userRoles.SALES_REPRESENTATIVE}
                status={salesConditions?.status}
            />
            {viewObjectionSection &&
                salesConditions &&
                salesConditions?.objectionsId?.length > 0 &&
                salesConditions?.objection && (
                    <div>
                        <AccordionComponent
                            id="Objection"
                            title="objections"
                            body={objectionBody()}
                            defaultExpanded
                        />
                    </div>
                )}
        </>
    );
}
